export const environment = {
  production: true,
  manifestConfigUrl: '/system-config/manifest.json',
  systemConfigUrl: '/system-config/settings.json',
  apiUrl: 'https://model-connector-ai-studio-ads.dev.internal.solutis.xyz',
  apiUrlPath: 'api/processText',
  accessManagementApiUrl:
    'https://access-management-api.plataforma-studioai.solutis.com.br/api/v1',
  bffUrl: 'https://ai-studio-bff.plataforma-studioai.solutis.com.br',
  orchestratorApiUrl:
    'https://model-orchestrator.plataforma-studioai.solutis.com.br/api',
  grafanaApiUrl: 'https://alloy.internal.solutis.xyz/collect',
  promptHubUrl:
    'https://prompt-hub-fed.plataforma-studioai.solutis.com.br/remoteEntry.js',
  enableGrafanaFaro: true,
  azureAd: {
    clientId: 'd00dfed6-6a96-4f80-a9e9-b9a6e0fad8e4',
    tenantId: 'c5dade78-23ca-4c48-86c5-ab8a9cdf6d79',
    redirectUri:
      'https://bradseg.plataforma-studioai.solutis.com.br/',
    authority:
      'https://login.microsoftonline.com/c5dade78-23ca-4c48-86c5-ab8a9cdf6d79',
    scopes: ['User.Read', 'ProfilePhoto.Read.All'],
  },
    keycloak: {
    clientId: 'studio-ai-app',
    authority: 'https://keycloak.plataforma-studioai.solutis.com.br/realms/bradseg-studio-ai/protocol/openid-connect/auth',
    redirectUri: 'https://bradseg.plataforma-studioai.solutis.com.br/callback',
    responseType: 'code',
    scope: 'openid'
  }
};
